"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = getPageContext;
const exenv_1 = require("exenv");
const emptyPageContext = {
    acceptLanguage: '',
    pageScripts: undefined,
    routeInfo: undefined,
    authToken: { token: null },
    getCsrfToken: () => '',
    csrfToken: '',
    locale: '',
    timeZone: '',
    uid: -1,
    tenant: {
        id: '',
        enabled: false,
        host: '',
        publicConfig: null,
        privateConfig: () => null,
        authProviders: () => null
    },
    pageRoutes: null,
    switchUserId: null,
    switchUserType: null,
    branchName: null,
    isCrawler: false,
    referrer: null
};
/**
 * Helper to get the next page context for use in both server and client.
 *
 * @param nextPageContext the next page context
 */
function getPageContext(nextPageContext) {
    var _a, _b;
    let pageContext = null;
    if (exenv_1.canUseDOM) {
        // eslint-disable-next-line no-underscore-dangle
        pageContext = (_b = (_a = window.__NEXT_DATA__) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b.pageProps;
    }
    else if (nextPageContext) {
        pageContext = nextPageContext.res.locals;
    }
    return pageContext !== null && pageContext !== void 0 ? pageContext : emptyPageContext;
}
//# sourceMappingURL=NextContextHelper.js.map